import { ForwardedRef, forwardRef, HTMLAttributes } from 'react'
import OriginalLink from 'next/link'
import { useTheme } from '@mui/material/styles'
import useIsIframe from 'hooks/useIsIframe'
import EventPropagationBlocker from 'components/EventPropagationBlocker'

interface ILinkProps extends HTMLAttributes<HTMLAnchorElement> {
  onClick?: () => void
  href?: string
  passHref?: boolean
  prefetch?: boolean
  replace?: boolean
  scroll?: boolean
  children: any
  shallow?: boolean
  style?: any // figure out why using the actual type creates type errors
}

/**
 * @deprecated use StyledLink or NextLinkComposed
 */
const Link = (props: ILinkProps, ref: ForwardedRef<HTMLAnchorElement>) => {
  const {
    onClick,
    href,
    passHref,
    prefetch,
    replace,
    scroll,
    children,
    shallow,
    style,
    ...others
  } = props

  const theme = useTheme()
  const isIframe = useIsIframe()

  let content = children

  // if Link component has onClick prop, we have to disable default action caused by using href attribute to prevent page reloading
  const handleClick = (e: any) => {
    e.preventDefault()
    onClick()
  }

  if (isIframe) {
    return (
      <a ref={ref} {...others} href={href} target="_parent" style={{ color: theme.palette.primary.main, ...style }}>
        {content}
      </a>
    )
  }

  if (typeof onClick === 'function') {
    return (
      <a ref={ref} {...others} href={href} onClick={handleClick} style={{ color: theme.palette.primary.main, ...style }}>
        {content}
      </a>
    )
  }

  content = (
    <a ref={ref} {...others} href={href} style={{ color: theme.palette.primary.main, ...style }}>
      {content}
    </a>
  )

  if ((typeof href !== 'string' || !href) && typeof onClick !== 'function') {
    console.warn('Link was rendered with an invalid HREF attribute.')
    return content
  }

  return (
    <EventPropagationBlocker component="span">
      <OriginalLink
        legacyBehavior
        onClick={onClick}
        href={href}
        passHref={passHref}
        prefetch={prefetch}
        scroll={scroll}
        replace={replace}
        shallow={shallow}
      >
        {content}
      </OriginalLink>
    </EventPropagationBlocker>
  )
}

export default forwardRef(Link)
